/* eslint-disable no-undef */
'use_strict';

// eslint-disable-next-line require-jsdoc
function isValidPhone(inputtxt) {
    var phoneNoRegex = /^\d{9,20}$/;
    if (inputtxt.match(phoneNoRegex)) {
        return true;
    }
    return false;
}
// eslint-disable-next-line require-jsdoc
function isValidEmail(inputtxt) {
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputtxt.match(emailRegex)) {
        return true;
    }
    return false;
}

module.exports = {
    isValidPhone: isValidPhone,
    isValidEmail: isValidEmail
};
